import { render, staticRenderFns } from "./tipoDocumentoForm.vue?vue&type=template&id=7c8fd345"
import script from "./tipoDocumentoForm.vue?vue&type=script&lang=js"
export * from "./tipoDocumentoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports